
import * as THREE from 'three';
import printModel from '../../3dapps/mixins/printModel';
import { initThree, scene, camera, renderer, incRenderCount, createFloor } from './scripts/initThree';
import XDialog from 'vux/src/components/x-dialog/index.vue'

import loading from '@/components/loading';
import { CurveEditor } from './scripts/CurveEditor';
import { ModelMaker } from './scripts/ModelMaker';

export default {
name: 'makeLeaf',
mixins: [printModel],
components: {
XDialog, loading
},
data() {
return {
quotationName: "树形首饰挂件",
productType: "树形首饰挂件",
landscape: true,
showLoading: false,
showPrint: false,
addCartIndex: -1,
orderIndex: -1,
showDownloads: false,
showSetImg: true,
showPrintImg: true,
showdownloadImg: true,
showCanvas2dBox: true,
}
},
mounted() {
const scope = this;
scope.showLoading = true;

initThree(scope.$refs.canvas3d);
scope.floor = createFloor();


const contentDOM = scope.$refs.makeLeaf;

const resize1 = function (e) {
if (!scope.$refs.canvas3d) return;


let w = scope.$refs.canvas3dBox.clientWidth;
let h = scope.$refs.canvas3dBox.clientHeight;



scope.$refs.canvas3d.width = w; 
scope.$refs.canvas3d.height = h; 



camera.aspect = w / h;

camera.updateProjectionMatrix();

renderer.setSize(w, h);
}
const resize2 = function (e) {
if (!scope.$refs.canvas2d) return;


let w = scope.$refs.canvas2dBox.clientWidth;
let h = scope.$refs.canvas2dBox.clientHeight;


scope.$refs.canvas2d.width = w; 
scope.$refs.canvas2d.height = h; 



camera.aspect = w / h;

camera.updateProjectionMatrix();

renderer.setSize(w, h);
}
scope.init3d(contentDOM, camera, renderer, resize1);
scope.init3d(contentDOM, camera, renderer, resize2);

let maker = new ModelMaker(document.getElementById("canvas3d"));
let drawer = new CurveEditor(document.getElementById("canvas2d"));

maker.init(scene);
maker.makeModel(drawer.toPaths());



incRenderCount();

setTimeout(() => {
scope.showLoading = false;
}, 100);
},
methods: {


isclickSet() {
this.showCanvas2dBox = !this.showCanvas2dBox;
console.log("this.showCanvas2dBox",this.showCanvas2dBox);
},


touchstart() {
this.isTopBtn();

},

isTopBtn() {
this.showPrint = false;
this.showTabList = false;
this.showDownloads = false;
this.showdownloadImg = true;
this.showPrintImg = true;
this.showdisplay = true;
this.showdisplayImg = true;
this.showSetImg = true;
this.showEraserImg = true;
this.showStrokesPop = false;


},


downloadsBtn() {
this.showDownloads = !this.showDownloads;
this.showdownloadImg = !this.showdownloadImg;
},


downloads() {
const scope = this;
scope.showDownloads = false;
scope.showLoading = true;

if (maker.group) {

if (!this.$common.getCookie('_token')) {

scope.saveData();

this.$router.push({
path: '/login',
query: {
fullPath: this.$route.fullPath
}
});
scope.showLoading = false;
} else {
scope.$request.post('/SmallSoftware/requestDownload', {
type: "penholder",
}).then(function (res) {
console.log("res", res);
if (res.obj === null) {
scope.$vux.toast.show({
text: '模型不能为空',
type: "warn",
time: 2000,
position: "middle",
});
scope.showLoading = false;
scope.showDownloads = false;
return;
} else {
scope.downloadModels();
setTimeout(() => {
scope.$vux.toast.show({
text: '下载成功',
type: "success",
time: 2000,
position: "middle",
});
scope.isTopBtn();
scope.showLoading = false;
}, 50);
}
});
}
} else {
scope.$vux.toast.show({
text: '模型不能为空',
type: "warn",
time: 2000,
position: "middle",
});
scope.showLoading = false;
scope.showDownloads = false;
return;
}
},

downloadModels() {
let exporter = new THREE.STLExporter();
let result = exporter.parse(maker.group, { binary: true });
let blob = new Blob([result], { type: 'application/octet-stream' });
let filename = "定制首饰挂件.stl";
let link = document.createElement("a");
link.href = URL.createObjectURL(blob);
link.download = filename;
link.click();
},

getModelToPrint() {
return maker.group;
},

makeStlBlob() {
let exporter = new THREE.STLExporter();
let group = maker.group;

let result = exporter.parse(group, { binary: true });
let blob = new Blob([result], { type: 'application/octet-stream' });
return blob;
},

getUploadUrl() {
return "/SmallSoftware/uploadFile";
},


print() {
this.modelSplit = true;
this.isTopBtn();
this.showLoading = true;
this.showPrintImg = !this.showPrintImg;

if (this.lowPrice == 0 && this.total <= 5 || this.total == 5) {
this.showlow = true;
this.showStyle = false;
this.showlowpriceHeight = true;
}
if (this.lowPrice == 1 && this.total > 5 || this.total > 5 || this.lowPrice == "") {
this.showlow = false;
this.showStyle = true;
this.showlowpriceHeight = false;
}

setTimeout(() => {
if (maker.group) {
this.saveData();
this.noUpdateMesh = false;
this.updateMesh();
this.$nextTick(function () {
this.showPrint = true;
this.makeModelForPrint();
this.getPrice();
});
} else {
this.$vux.toast.show({
text: '定制装饰画不能为空！',
type: "warn",
time: 2000,
position: "middle",
});
this.noUpdateMesh = false;
this.updateMesh();
}
incRenderCount();
this.showLoading = false;
}, 50);
},
},
}


// WEBPACK FOOTER //
// ./src/views/makeLeaf/script.js